module.exports = __webpack_public_path__ + "media/images/coupon-373b9a06ae47562ea16f9bf97360f383.svg";